import { render, staticRenderFns } from "./contrat.vue?vue&type=template&id=05ad1488&scoped=true"
import script from "./contrat.vue?vue&type=script&lang=js"
export * from "./contrat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ad1488",
  null
  
)

export default component.exports